export function base64ToArrayBuffer(base64: string): ArrayBuffer {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

export const isProd = (): boolean => {
  return process.env.REACT_APP_ENV === "prod";
};

export const isQA = (): boolean => {
  return process.env.REACT_APP_ENV === "qa";
};

export const isDBLogin = process.env.REACT_APP_DB_LOGIN_ENABLED === "true";
